import React from 'react';
import InventoryApprovalManagement from '../../../components/inventory/InventoryApproval';

const InventoryApproval = () => {
  return (
    <div className="min-h-screen bg-gray-50 p-4 sm:p-6">
      <InventoryApprovalManagement />
    </div>
  );
};

export default InventoryApproval;

